import { useEffect, useState } from "react";
import { focusManager } from "../utils/Focus";
// How many rows above/below the focused row keep their poster images loaded.
// Everything outside this window releases its texture to bound GPU memory.
export var ACTIVE_ROW_BUFFER = 2;
export var isWithinPosterWindow = function (rowIndex, focusedIndex) { return Math.abs(rowIndex - focusedIndex) <= ACTIVE_ROW_BUFFER; };
export var useTVScroll = function (_a) {
    var onEndReached = (_a === void 0 ? {} : _a).onEndReached;
    var _b = useState(false), scrollToTopVisible = _b[0], setScrollToTopVisible = _b[1];
    var _c = useState(null), focusedGroup = _c[0], setFocusedGroup = _c[1];
    useEffect(function () {
        var handleFocusChange = function (e) {
            var _a = e.detail, index = _a.index, total = _a.total, group = _a.group;
            setFocusedGroup(group !== null && group !== void 0 ? group : null);
            if (index >= total - 2) {
                if (onEndReached)
                    onEndReached();
            }
            if (index > 1) {
                setScrollToTopVisible(true);
            }
            else {
                setScrollToTopVisible(false);
            }
        };
        var handleEndReached = function () {
            if (onEndReached)
                onEndReached();
        };
        var handleKeyDown = function (e) {
            if (focusManager.isKey(e.keyCode, "TOP")) {
                setScrollToTopVisible(false);
                focusManager.jumpToTop();
            }
        };
        window.addEventListener("focus-group-change", handleFocusChange);
        window.addEventListener("focus-end-reached", handleEndReached);
        window.addEventListener("keydown", handleKeyDown);
        return function () {
            window.removeEventListener("focus-group-change", handleFocusChange);
            window.removeEventListener("focus-end-reached", handleEndReached);
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onEndReached]);
    return { scrollToTopVisible: scrollToTopVisible, focusedGroup: focusedGroup };
};



//////////////////
// WEBPACK FOOTER
// ./src/hooks/useTVScroll.ts
// module id = 26
// module chunks = 1